import React from 'react';
import css from './RewardBadge.module.scss';

interface RewardBadgeProps {
  head: string;
  value: number;
}

export const RewardBadge = ({ head, value }: RewardBadgeProps) => {
  return (
    <div className={css.rewardBadge}>
      <img
        className={css.imageBadge}
        src={'../../../static/scallop.png'}
        alt={'GL badge'}
      />
      <div className={css.badgeContent}>
        <p className={css.rewardText}>{head}</p>
        <div className={css.rewardValueContainer}>
          <p className={css.rewardValueSymbol}>$</p>
          <p
            className={`${css.reward} ${
              value > 99 ? css.greaterRewardValue : css.lowerRewardValue
            }`}
          >
            {value}
          </p>
        </div>
      </div>
    </div>
  );
};
